
export function getUser() {
  const user = sessionStorage.getItem("user");
  if (user === "undefined" || !user) {
    return null;
  } else {
    return JSON.parse(user);
  }
}
export function getUserToken() {
  return sessionStorage.getItem('userToken');
}
export function setUserSession(user, userToken) {
  sessionStorage.setItem('user', JSON.stringify(user));
  sessionStorage.setItem('userToken', userToken);
}
export function resetUserSession() {
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('userToken');
}
export function getVendor() {
  const vendor = sessionStorage.getItem("vendor");
  if (vendor === "undefined" || !vendor) {
    return null;
  } else {
    return JSON.parse(vendor);
  }
}
export function getVendorToken() {
  return sessionStorage.getItem("vendorToken");
}
export function setVendorSession(vendor, vendorToken) {
  sessionStorage.setItem("vendor", JSON.stringify(vendor));
  sessionStorage.setItem("vendorToken", vendorToken);
}
export function resetVendorSession() {
  sessionStorage.removeItem("vendor");
  sessionStorage.removeItem("vendorToken");
}


